






















































import Vue from 'vue'

import {Component, Prop} from 'vue-property-decorator'

@Component
export default class Pagination extends Vue {
  // name: 'pagination',
  @Prop({required: true, default: 1})
  value!: number

  @Prop({
    required: true,
    validator(value: number): boolean {
      return value >= 0
    },
    default: 1
  })
  totalPages!: number

  @Prop({default: false})
  disabled!: boolean

  @Prop({default: 'page_nav_btn'})
  navigationClass!: string

  @Prop({default: 'page_nav_btn_disabled'})
  navigationDisabledClass!: string

  @Prop({default: 'page_current'})
  currentPageClass!: string

  @Prop({default: 'text-muted'})
  skipClass!: string

  @Prop({default: 7})
  pagingWindowSize!: number

  changePage(page: number) {
    if (!this.disabled && page > 0 && page <= this.totalPages && page !== this.value) {
      this.$emit('input', page)
      this.$emit('change', page)
    }
  }

  get maxPagesDisplay() {
    return Math.min(this.totalPages, this.pagingWindowSize)
  }

  get windowLeftPage() {
    const leftNum = Math.floor(this.maxPagesDisplay / 2)
    const windowLeft = this.value - leftNum

    const adjustL = windowLeft < 1 ? 1 - windowLeft : 0

    return windowLeft + adjustL
  }

  get windowRightPage() {
    return this.windowLeftPage + (this.maxPagesDisplay - 1)
  }

  /**
   * Create list of page links to display
   */
  get pageList() {
    const pages: any[] = []
    let skipped = false
    const curPage = this.value

    // creates sliding window of size pagingWindowSize


    const totalPages1 = this.totalPages

    // assume total pages >1 because we do not show paging otherwise
    // and always show last page

    const minPage = this.windowLeftPage
    const maxPage = this.windowRightPage

    // always add first page
    pages.push({page: 1})

    for (let i = 2; i < totalPages1; i++) {
      let shouldSkip = false
      if (i < minPage || i > maxPage) {
        shouldSkip = true
      }
      if (!skipped && shouldSkip) {
        skipped = true
        pages.push({skip: true})
        continue
      } else if (skipped && !shouldSkip) {
        skipped = false
      }
      if (!skipped) {
        pages.push({page: i})
      }
    }

    // always add last page
    pages.push({page: totalPages1})

    return pages
  }

  get hasPreviousButton(): boolean {
    return this.value > 1
  }

  get hasNextButton(): boolean {
    return this.value < this.totalPages
  }
}
